<template>
  <div class="footer-menu">
    <van-tabbar router v-model="tabbarActive" :active-color="activeColor" :inactive-color="unActiveColor" placeholder>
      <!-- van-tabbar-item 默认为上下结构：图标在上、文字在下 -->
      <van-tabbar-item name="home" icon="home-o" :to="{path:'/home'}">首页</van-tabbar-item>
      <van-tabbar-item name="myTask" icon="todo-list-o" :to="{path:'/myTask'}">我的任务</van-tabbar-item>
      <van-tabbar-item name="service" icon="records" :to="{path:'/serviceRecord'}">服务记录</van-tabbar-item>
      <van-tabbar-item name="mine" icon="user-o" :to="{path:'/mineCenter'}">个人中心</van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
export default {
  name: 'FooterMenu',
  data () {
    return {
      tabbarActive: 'home',
      activeColor: '#e92504', // rgb(233, 37, 4)
      unActiveColor: '#999999'
    }
  },
  created () {
    this.initTabbarIndex()
  },
  methods: {
    initTabbarIndex () {
      const url = this.$route.path
      if (url.indexOf('/home') > -1) {
        this.tabbarActive = 'home'
      } else if (url.indexOf('/myTask') > -1) {
        this.tabbarActive = 'myTask'
      } else if (url.indexOf('/serviceRecord') > -1) {
        this.tabbarActive = 'service'
      } else if (url.indexOf('/mineCenter') > -1) {
        this.tabbarActive = 'mine'
      }
    }
  },
  watch: {
    $route (nval, oval) {
      this.initTabbarIndex()
    }
  }
}
</script>
<style scoped>
/* 白色背景：遮住页面灰色背景从 tabbar 占位区透出，与固定底部的白色导航条连成一体 */
.footer-menu {
  background: #ffffff;
}
</style>
